import useRepeater from './use-repeater';

export { useRepeater };

export default useRepeater;
